export default {
  entriesLoading: true,
  uid: null,
  shareUrl: null,
  entries: [],
};
